import { render, staticRenderFns } from "./OtelDemo.vue?vue&type=template&id=4459cc1a&scoped=true"
import script from "./OtelDemo.vue?vue&type=script&lang=js"
export * from "./OtelDemo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4459cc1a",
  null
  
)

export default component.exports